import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import { Modal } from "@mui/material";
import PropTypes from "prop-types";
import React, { useState } from "react";

import { CloseButton } from "../ImageUploadModal/ImageUploadModal.styles";
import {
  ImagePlaceholder,
  ModalBox,
  SkeletonPlaceholder,
  StyledImage,
  StyledLargeImage,
  StyledProfilePhotoContainer,
} from "./ProfilePhoto.styles";

export interface ProfilePhotoProps {
  src?: string;
  onPlaceholderClick: () => void;
  alt?: string;
}

const ProfilePhoto: React.FC<ProfilePhotoProps> = ({
  src,
  onPlaceholderClick,
  alt = "Profile Photo",
}) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const handleClose = () => {
    setOpenModal(false);
  };

  if (!src) {
    return (
      <ImagePlaceholder onClick={onPlaceholderClick}>No profile photo available</ImagePlaceholder>
    );
  }
  if (!isImageLoaded) {
    return (
      <>
        <img src={src} onLoad={() => setIsImageLoaded(true)} style={{ display: "none" }} />
        <SkeletonPlaceholder />
      </>
    );
  }

  return (
    <>
      <StyledProfilePhotoContainer onClick={() => setOpenModal(true)}>
        <StyledImage src={src} alt={alt} />
      </StyledProfilePhotoContainer>
      {openModal && (
        <Modal open={openModal} onClose={handleClose} aria-labelledby="image-upload-modal">
          <ModalBox>
            <StyledLargeImage src={src} alt={alt} />
            <CloseButton onClick={handleClose}>
              <CancelRoundedIcon />
            </CloseButton>
          </ModalBox>
        </Modal>
      )}
    </>
  );
};

ProfilePhoto.propTypes = {
  src: PropTypes.string,
  onPlaceholderClick: PropTypes.func.isRequired,
  alt: PropTypes.string,
};

export default ProfilePhoto;
